import React from 'react';
import PropTypes from 'prop-types';
import FormField from '../../../forms/_common/FormField';
import { OutlineButton } from '../../../@communityshare/ui/Button';
import { SolidButton } from '../../../@communityshare/ui/Button';
import StringField from '../../../forms/_fields_v2/StringField';
import FormTemplate from './Template';
import Enabled from './Options/Enabled';
import Disabled from './Options/Disabled';

Form.propTypes = {
  data: PropTypes.object,
  errors: PropTypes.object,
  showErrors: PropTypes.bool,
  alert: PropTypes.node,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func
};

Form.defaultProps = {
  // data: {},
  errors: {},
  showErrors: false,
  onChange: () => {}
};

export default function Form(props) {
  const {
    data,
    errors,
    showErrors,
    alert,
    onChange,
    onSubmit
  } = props;

  return (
    <FormTemplate
      // title="Leave a note"
      // subtitle="This note will be visible to everyone on your team."
      alert={alert}
      body={(
        <>
          <FormField name="grants" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <div className="space-y-10">
                <Enabled
                  selected={field.value === 'Yes'}
                  onClick={() => field.onChange('Yes')}
                />
                <Disabled
                  selected={field.value === 'No'}
                  onClick={() => field.onChange('No')}
                />
              </div>
            )}
          </FormField>
        </>
      )}
      footer={(
        <div className="flex justify-end">
          <SolidButton onClick={onSubmit}>
            Save
          </SolidButton>
        </div>
      )}
    />
  );
}
